import request from '../request';
import config from '@/config/index'
const { apiPath } = config

// 获取策略数据
export const getStrategys = params => {
	return request({
		url: `${apiPath()}/getStrategys`,
		method: 'get',
		params
	});
};
